import { CrudList } from '../shared/CrudPage';
import { salaryStructureService } from '@kss/api';
import type { SalaryStructure, SalaryStructureCreate, SalaryStructureFilter } from '@kss/api';
import { NameCell } from '../../hooks/useNameMaps';

export default function AllSalaryStructures() {
  return (
    <CrudList<SalaryStructure, SalaryStructureCreate, SalaryStructureFilter>
      title="Salary structures" newLabel="New structure" service={salaryStructureService}
      idKey="salaryStructureId" labelKey="employeeId" basePath="/panel/salary-structures"
      columns={[
        { accessor: 'employeeId', title: 'Employee', render: (r) => <NameCell kind="employee" id={r.employeeId} /> },
        { accessor: 'basicSalary', title: 'Basic (₹)', sortable: true, textAlign: 'right', render: (r) => Number(r.basicSalary ?? 0).toLocaleString('en-IN') },
        { accessor: 'hra', title: 'HRA', sortable: true, textAlign: 'right', render: (r) => Number(r.hra ?? 0).toLocaleString('en-IN') },
        { accessor: 'grossSalary', title: 'Gross (₹)', sortable: true, textAlign: 'right', render: (r) => Number(r.grossSalary ?? 0).toLocaleString('en-IN') },
        { accessor: 'netSalary', title: 'Net (₹)', sortable: true, textAlign: 'right', render: (r) => Number(r.netSalary ?? 0).toLocaleString('en-IN') },
        { accessor: 'effectiveFrom', title: 'Effective from', sortable: true, render: (r) => r.effectiveFrom ? new Date(r.effectiveFrom).toLocaleDateString() : '—' },
      ]}
    />
  );
}
